module.exports = __webpack_public_path__ + "assets/chat-history.c38de587775d598546d8d5085563b88b.svg";